export default {
  'returnedPurchases.label.filterByDate': 'Filtrar por data de',
  'returnedPurchases.label.status': 'Situação',

  'returnedPurchases.option.release': 'Lançamento',
  'returnedPurchases.option.emission': 'Emissão',
  'returnedPurchases.option.creditValue': 'Valor de crédito',
  'returnedPurchases.option.deductedAmount': 'Valor deduzido',

  'returnedPurchases.checkbox.usedCreditDetail': 'Detalhar créditos utilizados',
  'returnedPurchases.checkbox.creditToUseDetail':
    'Detalhar créditos a serem utilizados',
};
